import { ProductListing } from '../../../components/ProductListing/ProductListing';
import { Res, useCms } from '../../../state/api';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { Loader } from '../../Loader/Loader';

type CmsProductListSimpleProps = {
	title?: string;
	endpoint: string;
};

export const CmsProductListSimple = ({ title, endpoint }: CmsProductListSimpleProps): JSX.Element => {
	const { data, error } = useCms(Res.cmsEndpoint, { endpoint });

	if (error) return <ErrorMessage />;
	if (!data) return <Loader size="line" />;
	if (!data.products || data.products.length === 0) return <ErrorMessage />;

	return (
		<div>
			{title && <h2>{title}</h2>}
			<ProductListing products={data.products}></ProductListing>
		</div>
	);
};
